import axios from '../../../axios';
import IExcelImportTemplate from '../types/IExcelImportTemplate';

const excelTemplateBaseUrl = '/candidatesearch/api/excel-template';

export const saveOrUpdateTemplate = (template: IExcelImportTemplate) =>
  axios.post(`${excelTemplateBaseUrl}/save`, template);

export const getRecruiterTemplates = (isMapping: boolean) =>
  axios.get(`${excelTemplateBaseUrl}/get-templates/${isMapping}`);

export const deleteExcelTemplate = (templateId: string) =>
  axios.delete(`${excelTemplateBaseUrl}/delete-template/${templateId}`);

export const hideExcelTemplate = (templateId: string, isHidden: boolean) =>
  axios.post(`${excelTemplateBaseUrl}/hide-template/${templateId}/${isHidden}`);

export const starExcelTemplate = (templateId: string, isFavorite: boolean) =>
  axios.post(`${excelTemplateBaseUrl}/star-template/${templateId}/${isFavorite}`);
